<nz-layout style="width: 100vw">
  <nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
    <div class="flex items-center space-x-2 p-5">
      <img class="h-5 rounded-md" src="https://staging.journalocity.com/logo.jpeg" alt="" />
      <p *ngIf="!isCollapsed" class="text-lg text-white">Journalocity</p>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline">
      <li nz-menu-item [routerLink]="['/admin/dashboard/analytics']" routerLinkActive="/admin/dashboard/analytics">
        <span nz-icon nzType="dashboard"></span>
        <span>Dashboard</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/users']" routerLinkActive="/admin/users">
        <span nz-icon nzType="user"></span>
        <span>Users</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/categories']" routerLinkActive="/admin/categories">
        <span nz-icon nzType="partition" nzTheme="outline"></span>
        <span>Categories</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/articles']" routerLinkActive="/admin/articles">
        <span nz-icon nzType="book" nzTheme="outline"></span>
        <span>Articles</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/publications']" routerLinkActive="/admin/publications">
        <span nz-icon nzType="audit" nzTheme="outline"></span>
        <span>Publications</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/withdrawal']" routerLinkActive="/admin/withdrawal">
        <span nz-icon nzType="diff" nzTheme="outline"></span>
        <span>Withdrawal</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/global-settings']" routerLinkActive="/admin/global-settings">
        <span nz-icon nzType="diff" nzTheme="outline"></span>
        <span>Global Settings</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/orders']" routerLinkActive="/admin/orders">
        <span nz-icon nzType="diff" nzTheme="outline"></span>
        <span>Orders</span>
      </li>
      <li nz-menu-item [routerLink]="['/admin/email-compose']" routerLinkActive="/admin/email-compose">
        <span nz-icon nzType="mail" nzTheme="outline"></span>
        <span>Send Email</span>
      </li>
    </ul>
  </nz-sider>
  <nz-layout style="height: 100vh;">
    <nz-header class="flex justify-between items-center">
      <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
        (click)="isCollapsed = !isCollapsed"></span>
      <nz-button-group class="mr-3">
        <button nz-button (click)="log()">Admin</button>
        <button nz-button nz-dropdown [nzDropdownMenu]="menu2" nzPlacement="bottomRight">
          <span nz-icon nzType="user"></span>
        </button>
      </nz-button-group>
    </nz-header>
    <nz-content class="overflow-y-scroll">
      <div class="inner-content mt-4">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <nz-footer>journalocity ©2023</nz-footer>
  </nz-layout>
</nz-layout>
<nz-dropdown-menu #menu2="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item>My Profile</li>
    <li nz-menu-item (click)="onLogout()">Logout</li>
  </ul>
</nz-dropdown-menu>